module.exports = __webpack_public_path__ + "static/img/image_solutions_ime_08.8851cf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_ime_08.png
// module id = f4Yv
// module chunks = 10